import HotelManualEvent from '../../event/HotelManualEvent'
import AppDispatcher from '../../core/AppDispatcher'

const onDragItem = (srcIndex, targetIndex) => {
  AppDispatcher.dispatchWithType(HotelManualEvent.dragging, { srcIndex: srcIndex, targetIndex: targetIndex })
}

export default onDragItem
